import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ashtrom-corporate/app/[locale]/(nolayout)/bgrebuild/components/BgRebuild.tsx");
